/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.product-item').forEach(productCard => {

      /*
      ==========================================
      1. CORRECTION IMAGE VARIANTE
      ==========================================
      */

      const titleElement = productCard.querySelector('.product-item__title');
      if (titleElement) {
        const variantName = titleElement.innerText
          .trim()
          .split('-')
          .pop()
          .trim();

        const variantImage = productCard.querySelector(
          `.product-item__bg__inner[data-variant-title="${variantName}"] img`
        );

        const firstSlideImage = productCard.querySelector(
          '.product-item__bg__slider .product-item__bg__slide:first-child img'
        );

        if (variantImage && firstSlideImage) {
          firstSlideImage.src = variantImage.src;
          firstSlideImage.srcset = variantImage.srcset;
          firstSlideImage.alt = variantImage.alt;
        }
      }

      /*
      ==========================================
      2. SWIPE MOBILE UNIQUEMENT
      ==========================================
      */

      if (window.innerWidth <= 749) {
        const slider = productCard.querySelector('.product-item__bg__slider');
        if (!slider) return;
        const slides = slider.querySelectorAll('.product-item__bg__slide');
        if (slides.length < 2) return;

        // Activer uniquement le scroll tactile mobile
        slider.style.display = 'flex';
        slider.style.flexWrap = 'nowrap';
        slider.style.overflowX = 'auto';
        slider.style.scrollSnapType = 'x mandatory';
        slider.style.webkitOverflowScrolling = 'touch';

        const sliderWidth = slider.getBoundingClientRect().width;

        slides.forEach(slide => {
          slide.style.display = 'block';
          slide.style.flex = `0 0 ${sliderWidth}px`;
          slide.style.width = `${sliderWidth}px`;
          slide.style.scrollSnapAlign = 'start';

        });

        // Repositionner au début après changement de variante
        slider.scrollLeft = 0;
        console.log('Mobile swipe activé', {
          width: sliderWidth,
          scrollWidth: slider.scrollWidth,
          slides: slides.length
        });
      }
    });
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
